<template>
  <div class="atlaspage">
    <chart-block></chart-block>
  </div>
</template>

<script>
import Vue from 'vue'
import ChartBlock from '@/components/common/ChartsBlock.vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    ChartBlock
  },
  data() {
      return {
       
      };
    },
    methods: {
      
      getdownData(){
        //下载推荐
        api.getlistDraft({
            column:'downloads',order:'desc',field:'id',pageNo:1,pageSize:10,statusList:2,
          }).then((res)=>{
            // console.log(res)
            if(res.code==200&&res.result.records.length>0){
              this.downData=res.result.records
            }
          }).catch((err) => {
          });
      },
      getloadTreeData(){
        //专题分类
        let params = {
          async: false,
          pcode: ""
        };
        api.getloadTreeData(params)
          .then((res)=>{
            let treedatadiy=[]
            if(res.code==0&&res.result.length>0){
              this.treedata= this.diyTreeDataFn(res.result);
              
            }
          }).catch((err) => {
          });
      },
      diyTreeDataFn(data){
        let that=this;
        let treearr=[]
        for(let i in data){
          if(data[i].children&&data[i].children.length>0){
            
            treearr.push({
              label: data[i].title,
              children:that.diyTreeDataFn(data[i].children)
            })
          }else{
            treearr.push({
              label: data[i].title,
            })
          }
        }
          return treearr
      },
    },
  created(){
      
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" >
.atlaspage{
  width: 800px;
  height: 600px;
  margin: 0 auto;
}
</style>
